import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Condition } from '@core/bean/condition';
import * as format from 'date-fns/format';
import { BrowseService } from '../browse/browse.service';
import { BrowseConfig } from '@core/bean/browse-config';
import { NzTreeNode } from 'ng-zorro-antd';
import { CommonsService } from '@core/service/commons.service';
import { CacheService } from '@delon/cache';

@Component({
  selector: 'pagination-search',
  templateUrl: './pagination-search.html',
  styleUrls: ['./pagination-search.less']
})

export class PaginationSearchComponent implements OnInit {
  ngOnInit():void {
    let conditions = null;
    if (this.modelName) {
      conditions = this.srv.get(this.modelName);
    }
    if (conditions&&conditions['value']) {
      this.conditionShows = conditions['value'];
    } else {
      this.conditionShows = this.conditions;
    }
  }

  @Input() modelName:string;

  @Input() conditions:Condition[];
  conditionShows:Condition[] = [];
  expandForm:boolean = false;
  searchData = {};
  rangeDate = {};
  browseDate = {};
  isVisible:boolean = false;
  conditionTree:any[] = [];
  @Output() getData = new EventEmitter();

  constructor(private browseService:BrowseService, private commonsService:CommonsService, private srv:CacheService) {
  }

  setting() {
    this.isVisible = true;
  }

  getConditions() {
    if (this.conditions && this.conditions.length > 0) {
      let conditionTree = [];
      for (let i = 0; i < this.conditions.length; i++) {
        let data = this.conditions[i];
        let excelTitleNode = [];
        conditionTree.push(new NzTreeNode({
          title: this.commonsService.translate(data['label']),
          isLeaf: true,
          key: "" + i,
          checked: true,
          children: []
        }))
      }
      this.conditionTree = conditionTree;
    }
  }

  confrim() {
    let newConditions = [];
    for (let i = 0; i < this.conditionTree.length; i++) {
      if (this.conditionTree[i].isChecked) {
        newConditions.push((this.conditions)[this.conditionTree[i].key]);
      }
    }
    if (newConditions.length == 0) {
      this.commonsService.showErrorMessage("shared.score.pagination-search.leastOne");
      return;
    }
    this.conditionShows = newConditions;
    this.srv.set(this.modelName, newConditions);
    this.isVisible = false;
  }

  /**
   * 关闭
   */
  handleCancel():void {
    this.isVisible = false;
  }

  search() {
    let searchData = this.searchData;
    for (let i = 0; i < this.conditionShows.length; i++) {
      const condition = (this.conditionShows)[i];
      if (condition.searchType == 'rangeDate') {
        if (this.rangeDate[condition['searchName']]) {
          //searchData[condition['searchName'] + "-ge"] = format((this.rangeDate[condition['searchName']])[0], 'YYYY-MM-DD HH:mm:ss');
          //searchData[condition['searchName'] + "-le"] = format(new Date((this.rangeDate[condition['searchName']])[1].getTime() + 24 * 60 * 60 * 1000), 'YYYY-MM-DD HH:mm:ss');
          if((this.rangeDate[condition['searchName']])[0]){
            searchData[condition['searchName'] + "-ge"] = new Date((this.rangeDate[condition['searchName']])[0].setHours(0, 0, 0, 0));
          }else{
            searchData[condition['searchName'] + "-ge"] = null;
          }
          if((this.rangeDate[condition['searchName']])[1]){
            searchData[condition['searchName'] + "-le"] = new Date((this.rangeDate[condition['searchName']])[1].setHours(23, 59, 59, 999));
          }else{
            searchData[condition['searchName'] + "-le"] = null;
          }
        } else {
          searchData[condition['searchName'] + "-ge"] = "";
          searchData[condition['searchName'] + "-le"] = "";
        }
      } else if (condition.searchType == 'date') {
        if (this.searchData[condition['searchName']]) {
          this.searchData[condition['searchName']] = format((this.searchData[condition['searchName']]), 'YYYY-MM-DD HH:mm:ss');
        }
      }
    }
    this.getData.emit(searchData);
  }

  reset() {
    let searchData = this.searchData;
    this.rangeDate = {};
    for (let name in searchData) {
      searchData[name] = '';
    }
    this.getData.emit(searchData);
  }

  openModal(condition) {
    let config = new BrowseConfig(condition['browseName']);
    config.isEdit = true;
    this.browseService.open(config,
      (result) => {
        this.browseDate[condition['searchName']] = result[condition['browseParamName']];
        this.searchData[condition['searchName']] = result[condition['browseParamValue']];
      },
      () => {
      })
  }
}
